import React from "react";
import {Route, Routes} from "react-router-dom";
import User from "./User";
import UserList from "./UserList";

export default function Users() {
    return (
        <Routes>
            <Route path=":id" element={<User/>}/>
            <Route path="/" element={<UserList/>}/>
        </Routes>
    );
}